const API_BASE_URL = process.env.REACT_APP_BASE_API_URL;

export const getPaymentsApi = async ({ action, page = 1, perPage = 20 }) => {
    const token = localStorage.getItem('token');
    if (!token) throw new Error('Token not found');

    const params = new URLSearchParams();
    params.append('page', String(page));
    params.append('per_page', String(perPage));

    if (action) {
        params.append('action', action);
    }

    const res = await fetch(
        `${API_BASE_URL}/admin/lead/leads/payments?${params}`,
        {
            headers: {
                Accept: 'application/json',
                Authorization: `Bearer ${token}`,
            },
        }
    );

    if (!res.ok) {
        const err = await res.json();
        throw { ...err, statusCode: res.status };
    }

    const json = await res.json();
    return {
        data: json.data,
        meta: {
            total: json.meta.total,
            currentPage: json.meta.current_page,
            perPage: json.meta.per_page,
            lastPage: json.meta.last_page,
        },
    };
};
